module.exports = __webpack_public_path__ + "img/02时东升.fc62759a.png";